import { createSlice } from "@reduxjs/toolkit";
import { TipoTaxaImpostoModel } from "../../../models/tipoTaxaImposto/tipoTaxaImpostoModel";
import { buscarTipoTaxaImposto } from "../../../services/tipoTaxaImpostoService";
import { resetAll } from "../../actions/actions";

export interface TipoTaxaImpostoState {
  //buscar tipo taxa imposto
  loading: boolean;
  busca: string;
  list: TipoTaxaImpostoModel[];
  entity: TipoTaxaImpostoModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: TipoTaxaImpostoState = {
  //buscar tipo taxa imposto
  loading: false,
  busca: "",
  list: [],
  entity: {} as TipoTaxaImpostoModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const tipoTaxaImpostoSlice = createSlice({
  name: "tipoTaxaImposto",
  initialState,
  reducers: {
    setBuscaTipoTaxaImposto: (state, action) => {
      state.busca = action.payload;
    },
    setEntityTipoTaxaImposto: (state, action) => {
      state.entity = action.payload;
    },
    setModalCadastrarTipoTaxaImposto: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarTipoTaxaImposto: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar tipo taxa imposto
    builder.addCase(buscarTipoTaxaImposto.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarTipoTaxaImposto.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarTipoTaxaImposto.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar tipo taxa imposto
  setBuscaTipoTaxaImposto,
  setEntityTipoTaxaImposto,
  //internal
  setModalCadastrarTipoTaxaImposto,
  setModalDeletarTipoTaxaImposto,
} = tipoTaxaImpostoSlice.actions;

export default tipoTaxaImpostoSlice.reducer;
